<div class="header">
  <p class="text-white">{{ headerTxt }} beneficiario</p>
  <button *ngIf="isUpdate" mat-button class="invert flat" (click)="deleteBeneficiary()">
    <fa-icon class="fs-14 my-auto" [icon]="trash"></fa-icon>
  </button>
</div>

<form [formGroup]="beneficiaryForm">

  <div class="body">
    <mnf-input-form flat="1" formControlName="name" label="Nombre completo de beneficiario"
      placeholder="Ej: JOSE BUENAVENTURA SALAZAR" errMsg="Debe estar lleno éste campo">
    </mnf-input-form>

    <mnf-input-form flat="1" mask="SSSS 000000 SSSSSS AA" label="CURP" formControlName="curp" *ngIf="!isUpdate"
      placeholder="XXXX 000000 SSSSSS 00" errMsg="Debe estar lleno éste campo" [dropSpecialCharacters]="true">
    </mnf-input-form>

    <mnf-input-form flat="1" formControlName="percent" mask="999" label="Porciento" [placeholder]="placeholderPercent"
      errMsg="Debe estar lleno éste campo">
    </mnf-input-form>

    <mnf-input-form flat="1" formControlName="address" label="Dirección"
      placeholder="Ej: BOULEVARD MANUEL ÁVILA CAMACHO 118, PISO 16, LOMAS DE CHAPULTEPEC"
      errMsg="Debe estar lleno éste campo" *ngIf="!isUpdate">
    </mnf-input-form>

    <div class="w-100 text-center">
      <button class="btn" type="button" mat-button="mat-button" (click)="addBeneficiary()">
        {{ btnTxt }}
      </button>
    </div>
  </div>

</form>
